"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.splice.js");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _scrollbarWidth = _interopRequireDefault(require("element-ui/lib/utils/scrollbar-width"));

var _vue = _interopRequireDefault(require("vue"));

var _util = require("./util");

/* eslint-disable no-prototype-builtins */
var TableLayout = /*#__PURE__*/function () {
  function TableLayout(options) {
    (0, _classCallCheck2["default"])(this, TableLayout);
    this.observers = [];
    this.table = null;
    this.store = null;
    this.columns = null;
    this.fit = true;
    this.showHeader = true;
    this.height = null;
    this.scrollX = false;
    this.scrollY = false;
    this.bodyWidth = null;
    this.fixedWidth = null;
    this.rightFixedWidth = null;
    this.tableHeight = null;
    this.headerHeight = 44; // Table Header Height

    this.appendHeight = 0; // Append Slot Height

    this.footerHeight = 44; // Table Footer Height

    this.viewportHeight = null; // Table Height - Scroll Bar Height

    this.bodyHeight = null; // Table Height - Table Header Height

    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height

    this.gutterWidth = (0, _scrollbarWidth["default"])();

    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }

    if (!this.table) {
      throw new Error('table is required for Table Layout');
    }

    if (!this.store) {
      throw new Error('store is required for Table Layout');
    }
  }

  (0, _createClass2["default"])(TableLayout, [{
    key: "updateScrollY",
    value: function updateScrollY() {
      var height = this.height;
      if (typeof height !== 'string' && typeof height !== 'number') return;
      var bodyWrapper = this.table.bodyWrapper;

      if (this.table.$el && bodyWrapper) {
        var body = bodyWrapper.querySelector('.el-table__body');
        this.scrollY = body.offsetHeight > this.bodyHeight;
      }
    }
  }, {
    key: "setHeight",
    value: function setHeight(value) {
      var _this = this;

      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
      if (_vue["default"].prototype.$isServer) return;
      var el = this.table.$el;

      if (typeof value === 'string' && /^\d+$/.test(value)) {
        value = Number(value);
      }

      this.height = value;
      if (!el && (value || value === 0)) return _vue["default"].nextTick(function () {
        return _this.setHeight(value, prop);
      });

      if (typeof value === 'number') {
        el.style[prop] = value + 'px';
        this.updateElsHeight();
      } else if (typeof value === 'string') {
        el.style[prop] = value;
        this.updateElsHeight();
      }
    }
  }, {
    key: "setMaxHeight",
    value: function setMaxHeight(value) {
      return this.setHeight(value, 'max-height');
    }
  }, {
    key: "updateElsHeight",
    value: function updateElsHeight() {
      var _this2 = this;

      if (!this.table.$ready) return _vue["default"].nextTick(function () {
        return _this2.updateElsHeight();
      });
      var _this$table$$refs = this.table.$refs,
          headerWrapper = _this$table$$refs.headerWrapper,
          appendWrapper = _this$table$$refs.appendWrapper,
          footerWrapper = _this$table$$refs.footerWrapper;
      this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
      if (this.showHeader && !headerWrapper) return;
      var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;

      if (this.showHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
        return _vue["default"].nextTick(function () {
          return _this2.updateElsHeight();
        });
      }

      var tableHeight = this.tableHeight = this.table.$el.clientHeight;

      if (this.height !== null && (!isNaN(this.height) || typeof this.height === 'string')) {
        var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
        this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
      }

      this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;
      var noData = !this.table.data || this.table.data.length === 0;
      this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;
      this.updateScrollY();
      this.notifyObservers('scrollable');
    }
  }, {
    key: "getFlattenColumns",
    value: function getFlattenColumns() {
      var flattenColumns = [];
      var columns = this.table.columns;
      columns.forEach(function (column) {
        if (column.isColumnGroup) {
          flattenColumns.push.apply(flattenColumns, column.columns);
        } else {
          flattenColumns.push(column);
        }
      });
      return flattenColumns;
    }
  }, {
    key: "updateColumnsWidth",
    value: function updateColumnsWidth() {
      if (_vue["default"].prototype.$isServer) return;
      var fit = this.fit;
      var bodyWidth = this.table.$el.clientWidth;
      var bodyMinWidth = 0;
      var flattenColumns = this.getFlattenColumns(); // 扩展 将所有列进行排序

      var currentCol = this.store.states.currentCol;
      flattenColumns.forEach(function (column, index) {
        // Clean those columns whose width changed from flex to unflex
        if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
        column.flattenColumnIndex = index;
        if (currentCol && currentCol.id === column.id) currentCol.flattenColumnIndex = index;
      }); // 扩展 解决table调整column宽度时计算出错的问题
      // 扩展 只调整index大于正在调整宽度的列index的列

      var isSortDragging = this.store.states.isSortDragging;
      var flexColumns = flattenColumns.filter(function (column) {
        var shouldFix = true;

        if (currentCol) {
          shouldFix = column.flattenColumnIndex >= currentCol.flattenColumnIndex || isSortDragging;
        }

        return typeof column.width !== 'number' && column.show && shouldFix;
      });

      if (flexColumns.length > 0 && fit) {
        flattenColumns.forEach(function (column) {
          // 扩展 修复列显示隐藏 body width计算bug

          /** **/
          if (!column.show) {
            // bodyMinWidth += column.width || column.minWidth || 80;
            return;
          }

          if (currentCol && column.flattenColumnIndex < currentCol.flattenColumnIndex && !isSortDragging) {
            bodyMinWidth += column.width || column.realWidth;
          } else {
            bodyMinWidth += column.width || column.minWidth || _util.MIN_WIDTH;
          }
          /** **/

        });
        var scrollYWidth = this.scrollY ? this.gutterWidth : 0;

        if (bodyMinWidth <= bodyWidth - scrollYWidth) {
          // DON'T HAVE SCROLL BAR
          this.scrollX = false;
          var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;

          if (flexColumns.length === 1) {
            flexColumns[0].realWidth = (flexColumns[0].minWidth || _util.MIN_WIDTH) + totalFlexWidth;
          } else {
            var allColumnsWidth = flexColumns.reduce(function (prev, column) {
              return prev + (column.minWidth || _util.MIN_WIDTH);
            }, 0);
            var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
            var noneFirstWidth = 0;
            flexColumns.forEach(function (column, index) {
              if (index === 0) return;
              var flexWidth = Math.floor((column.minWidth || _util.MIN_WIDTH) * flexWidthPerPixel);
              noneFirstWidth += flexWidth;
              column.realWidth = (column.minWidth || _util.MIN_WIDTH) + flexWidth;
            });
            flexColumns[0].realWidth = (flexColumns[0].minWidth || _util.MIN_WIDTH) + totalFlexWidth - noneFirstWidth;
          }
        } else {
          // HAVE HORIZONTAL SCROLL BAR
          this.scrollX = true;
          flexColumns.forEach(function (column) {
            column.realWidth = column.minWidth;
          });
        }

        this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
        this.table.resizeState.width = this.bodyWidth;
      } else {
        flattenColumns.forEach(function (column) {
          if (!column.width && !column.minWidth) {
            column.realWidth = _util.MIN_WIDTH;
          } else {
            column.realWidth = column.width || column.realWidth || column.minWidth;
          } // 扩展 解决table调整column宽度时计算出错的问题


          if (column.show) {
            bodyMinWidth += column.realWidth;
          }
        });
        this.scrollX = bodyMinWidth > bodyWidth;
        this.bodyWidth = bodyMinWidth;
      }

      var fixedColumns = this.store.states.fixedColumns;

      if (fixedColumns.length > 0) {
        var fixedWidth = 0;
        fixedColumns.forEach(function (column) {
          fixedWidth += column.realWidth || column.width;
        });
        this.fixedWidth = fixedWidth;
      }

      var rightFixedColumns = this.store.states.rightFixedColumns;

      if (rightFixedColumns.length > 0) {
        var rightFixedWidth = 0;
        rightFixedColumns.forEach(function (column) {
          rightFixedWidth += column.realWidth || column.width;
        });
        this.rightFixedWidth = rightFixedWidth;
      } // 扩展 设置正在调整宽度的状态


      this.store.isSortDragging(false); // 将当前列清楚
      // this.store.setCurrentCol(null);

      this.notifyObservers('columns');
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.push(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      var index = this.observers.indexOf(observer);

      if (index !== -1) {
        this.observers.splice(index, 1);
      }
    }
  }, {
    key: "notifyObservers",
    value: function notifyObservers(event) {
      var _this3 = this;

      var observers = this.observers;
      observers.forEach(function (observer) {
        switch (event) {
          case 'columns':
            observer.onColumnsChange(_this3);
            break;

          case 'scrollable':
            observer.onScrollableChange(_this3);
            break;

          default:
            throw new Error("Table Layout don't have event ".concat(event, "."));
        }
      });
    }
  }]);
  return TableLayout;
}();

var _default = TableLayout;
exports["default"] = _default;